import { cellRenderParseDataAndTime } from '../../../utils/functions';

/** Список полей */
const columnDataGrid = [
  {
    dataField: 'userName',
    dataType: 'string',
    caption: 'Логин'
  },
  {
    dataField: 'fullName',
    dataType: 'string',
    caption: 'ФИО',
    cssClass: 'td-button-cell-render'
  },
  {
    dataField: 'plantShortDescr',
    dataType: 'string',
    caption: 'Склад',
    cssClass: 'td-button-cell-render'
  },
  {
    dataField: 'sessionStart',
    dataType: 'date',
    caption: 'Время начала',
    cellRender: cellRenderParseDataAndTime
  },
  {
    dataField: 'sessionEnd',
    dataType: 'date',
    caption: 'Время конца',
    cellRender: cellRenderParseDataAndTime
  }
];

export default columnDataGrid;
